import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColaboradoresService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusColaboradores(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusColaboradores(datos){
    console.log("datos colab::",datos);
    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoColaboradores(datos){
    console.log("datos colab::",datos);
    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	colaboradores: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  guardaColaboradores(productoId:any, nombres: any, bd: any, nameUserAdmin?:any){
    this.obtienInfo();
    let datos: any = {productoId, columnas: nombres, bdcolaboradores:bd, accionText:"subBaseColab", userAdministrator:nameUserAdmin};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaColaboradores + this.idEmpresa, datos);
  }
  guardaColaboradoresFocusFiltrados(productoId:any, nombres: any, bd: any){
    this.obtienInfo();
    let datos: any = {productoId, columnas: nombres, bdcolaboradores:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaColaboradores+ this.idEmpresa, datos);
  }
  guardaColaboradoresEmpresa(nombres: any, bd: any){
    let datos: any = {columnas: nombres, bdcolaboradores:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaColaboradoresEmpresa + localStorage.getItem('companyID'), datos);
  }

  getColaboradoresEmpresaFoc(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getColaboradoresEmpresaFocus + localStorage.getItem('companyID'));
  }

  getFiltersDemograficosFocus(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFiltersDemograFocus + localStorage.getItem('companyID'));
  }

  getFiltersDemograficosKey(key){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFiltersDemograKey + localStorage.getItem('companyID')+'/'+key);
  }
  deleteColaboradoresEmpresaFoc(){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.deleteColaboradoresEmpresaFocus + localStorage.getItem('companyID'));
  }
  postColaboradoresFiltradosEmpresaFoc(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.postColaboradoresFiltrados + localStorage.getItem('companyID'),datos);
  }

  getColaboradoresFast(producto: string){
    this.obtienInfo();
    let datos: any = {productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFast + this.idEmpresa, datos);
  }

  getActualizarColaboradoresFast(anio: number, producto: string, idEmpresa:string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFast + idEmpresa, datos);
  }

  getColaboradoresFull(producto: string,nameUserAdmin?:any){
    this.obtienInfo();
    let datos: any = {productoId:producto,accionText:'downloadBaseColab',userAdministrator:nameUserAdmin};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFull + this.idEmpresa, datos);
  }

  getColaboradoresFullNew(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFullNew + this.idEmpresa);
  }

  getColaboradoresActualizarFull(anio: number, producto: string, empresaId:string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFull + empresaId, datos);
  }

  borrarColaboradores(producto: string,nameUserAdmin?:any){
    this.obtienInfo();
    let datos: any = {productoId:producto,accionText:'deleteBaseColab',userAdministrator:nameUserAdmin};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarColaboradores + this.idEmpresa, datos);
  }

  getTiposDemograficos(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getTiposDemograficos + this.idEmpresa, datos);
  }

  getDemograficosGuardados(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDemograficosGuardados + this.idEmpresa, datos);
  }

  getIdiomasProd(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  //Funciones  para Colaboradores PulseCheck
  getStatusColaboradoresPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusColaboradoresPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  desbloquearPasoColaboradoresPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  guardaColaboradoresPulse(anio: any, nombres: any, bd: any){
    this.obtienInfo();
    let datos: any = {productoId: anio, columnas: nombres, bdcolaboradores:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaColaboradores + this.idEmpresa, datos);
  }

  getColaboradoresFastPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getColaboradoresFast + this.idEmpresa, datos);
  }

  getColaboradoresFullPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getColaboradoresFull + this.idEmpresa, datos);
  }

  borrarColaboradoresPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.borrarColaboradores + this.idEmpresa, datos);
  }


//MEDIR
  getStatusColaboradoresMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusColaboradoresMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoColaboradoresMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	colaboradores: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  getColaboradoresFastMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getColaboradoresFast + this.idEmpresa, datos);
  }
  borrarColaboradoresMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.borrarColaboradores + this.idEmpresa, datos);
  }

  guardaColaboradoresMedir(anio: any, nombres: any, bd: any){
    this.obtienInfo();
      let datos: any = {productoId: anio, columnas: nombres, bdcolaboradores:bd};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaColaboradores + this.idEmpresa, datos);
    }
  getColaboradoresFullMedir(anio: any){
    this.obtienInfo();
      let datos: any = {productoId: anio};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getColaboradoresFull + this.idEmpresa, datos);
    }

    getIdiomasMedir(id:any){
      this.obtienInfo();
      let datos: any = {productoId: id};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getIdiomasGuardados + this.idEmpresa, datos);
    }

    ///Focus Area
   guardaColaboradoresFocusArea(nombres: any, bd: any){
     this.obtienInfo();

      let datos: any = {empresaId:this.idEmpresa,columnas: nombres, bdcolaboradores:bd};
      console.log(datos);
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaColaboradores + localStorage.getItem('encuestaID'), datos);
    }
   borrarColaboradoresFocusArea(datos){

      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.borrarColaboradores + localStorage.getItem('encuestaID'), datos);
    }

   getColaboradoresFullFocusArea(datos){

      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getInfoColaboradoresFull+ localStorage.getItem('encuestaID'), datos);
    }

    getColaboradoresFastFocusArea(datos){
      // let datos: any = {productoId: anio};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getColaboradoresFast +localStorage.getItem('encuestaID'), datos);
    }

    guardaStatusColaboradoresFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	colaboradores: 3};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
    }

    desbloquearPasoColaboradoresFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	colaboradores: 2};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
    }
    getStatusColaboradoresFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	colaboradores: 1};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusPart + this.idEmpresa, datos);
    }

    getFull_CT(anio: number, producto: string){
this.obtienInfo();
      let datos: any = {fechaCertificar: anio, productoId:producto};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCTFull + this.idEmpresa, datos);
    }


    getHistoriaCreacionColaboradores(){
      let tipo=1;
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.historialesCer3.getHistorialColActCrea+localStorage.getItem('productoID') + "/"+tipo);
    }

    getVersionExcel(){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.versionExcel.get + localStorage.getItem('instituto_id'));
    }
    setVersionExcel(version:string){
      let datos = {
        brokerId: parseInt(localStorage.getItem('instituto_id')),
        version
      };
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.versionExcel.set, datos);
    }

    //ENVIO DE DATOS AL BACKEND ANALISIS DE EXCEL ._. XD
    enviarBD_analisis(datos:any){
      return this.http.post(DATOS_API.urlAnalisisExcel + DATOS_API.endpoints.analisisExcel.enviarBD, datos);
    }

    getSeccionesSurvey(){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.getSeccionesSurvey + localStorage.getItem('productoID'));
    }

    setSeccionesEspeciales(datos:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.setSeccionesEspeciales + localStorage.getItem('companyID'), datos);
    }

    setPreguntasEspeciales(){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.setPreguntasEspeciales + localStorage.getItem('companyID'), { productoId: localStorage.getItem('productoID') });
    }
}
